'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (duration) {
    return !!duration && duration.slice(-1) === 't';
};